var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter green",on:{"click":_vm.copyToClipboard}},[_c('feather-icon',{attrs:{"type":"copy"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }